import React from "react"
import Login from "./Screens/Login"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { Provider } from "react-redux"
import { HelmetProvider } from "react-helmet-async" // 1. Import this
import mystore from "./redux/store"
import { UiPreferencesProvider } from "./context/UiPreferencesContext"
import StudentHome from "./Screens/Student/Home"
import FacultyHome from "./Screens/Faculty/Home"
import AdminHome from "./Screens/Admin/Home"
import ForgetPassword from "./Screens/ForgetPassword"
import UpdatePassword from "./Screens/UpdatePassword"
import LandingPage from "./Screens/LandingPage"
import ChatWindow from "./ChatWindow"
import BedAdmissionOdisha from "./Screens/Seo/BedAdmissionOdisha"
import BpedAdmissionOdisha from "./Screens/Seo/BpedAdmissionOdisha"
import BedAdmissionBhadrak from "./Screens/Seo/BedAdmissionBhadrak"
import BedAdmissionBalasore from "./Screens/Seo/BedAdmissionBalasore"
import BedAdmissionBaripada from "./Screens/Seo/BedAdmissionBaripada"
import BedAdmissionMayurbhanj from "./Screens/Seo/BedAdmissionMayurbhanj"
import BedAdmissionKaranjia from "./Screens/Seo/BedAdmissionKaranjia"
import BedBpedKashmirGuidance from "./Screens/Seo/BedBpedKashmirGuidance"
import BedBpedWestBengalGuidance from "./Screens/Seo/BedBpedWestBengalGuidance"
import BedBpedAndhraGuidance from "./Screens/Seo/BedBpedAndhraGuidance"
import Appointment from "./Screens/Appointment"
import { Toaster } from "react-hot-toast"
import { PortalGlobalToastsGate } from "./components/GlobalChatToasts"

const App = () => {
  return (
    // 2. Wrap everything in HelmetProvider
    <HelmetProvider>
      <Provider store={mystore}>
        <UiPreferencesProvider>
        <Router>
          <PortalGlobalToastsGate />
          <Toaster
            position="top-right"
            reverseOrder={false}
            containerStyle={{ top: 12, right: 12 }}
            toastOptions={{
              duration: 4000,
              className: "font-medium text-slate-800",
              style: {
                borderRadius: "14px",
                padding: "12px 14px",
                boxShadow:
                  "0 10px 40px -10px rgb(15 23 42 / 0.2), 0 0 0 1px rgb(226 232 240 / 0.9)",
              },
              success: {
                duration: 4000,
                iconTheme: { primary: "#059669", secondary: "#ecfdf5" },
              },
            }}
          />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route
              path="/b-ed-admission-odisha"
              element={<BedAdmissionOdisha />}
            />
            <Route
              path="/b-p-ed-admission-odisha"
              element={<BpedAdmissionOdisha />}
            />
            <Route
              path="/b-ed-admission-bhadrak"
              element={<BedAdmissionBhadrak />}
            />
            <Route
              path="/b-ed-admission-balasore"
              element={<BedAdmissionBalasore />}
            />
            <Route
              path="/b-ed-admission-baripada"
              element={<BedAdmissionBaripada />}
            />
            <Route
              path="/b-ed-admission-mayurbhanj"
              element={<BedAdmissionMayurbhanj />}
            />
            <Route
              path="/b-ed-admission-karanjia"
              element={<BedAdmissionKaranjia />}
            />
            <Route
              path="/kashmir-bed-bped-admission-odisha"
              element={<BedBpedKashmirGuidance />}
            />
            <Route
              path="/west-bengal-bed-bped-admission-odisha"
              element={<BedBpedWestBengalGuidance />}
            />
            <Route
              path="/andhra-bed-bped-admission-odisha"
              element={<BedBpedAndhraGuidance />}
            />
            <Route path="/appointment" element={<Appointment />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route path="/chat" element={<ChatWindow />} />
            <Route
              path="/:type/update-password/:resetId"
              element={<UpdatePassword />}
            />
            <Route path="/student" element={<StudentHome />} />
            <Route path="/faculty" element={<FacultyHome />} />
            <Route path="/admin" element={<AdminHome />} />
          </Routes>
        </Router>
        </UiPreferencesProvider>
      </Provider>
    </HelmetProvider>
  )
}

export default App